interface Link {
  title: string;
  link: string;
}

export interface LinkSection {
  heading: string;
  links: Link[];
}

export const linkSections: LinkSection[] = [
  {
    heading: "Core services",
    links: [
      {
        title: "Rubbish Removal",
        link: "/rubbish-clearance",
      },
      {
        title: "Skip Hire",
        link: "/skip-hire",
      },
      {
        title: "Sofa Removal",
        link: "/sofa-removal",
      },
      {
        title: "Business Waste",
        link: "/business-waste",
      },
      {
        title: "Skip Bags",
        link: "/skip-bags",
      },
      {
        title: "Bin Collection",
        link: "/private-bin-collection",
      },
      {
        title: "Commercial Skip Hire",
        link: "/skip-hire/commercial",
      },
    ],
  },
  {
    heading: "Where we operate",
    links: [
      {
        title: "Nationwide",
        link: "/locations",
      },
      {
        title: "London",
        link: "/locations/london-rubbish-removal",
      },
      {
        title: "Birmingham",
        link: "/locations/birmingham-rubbish-removal",
      },
      {
        title: "Bristol",
        link: "/locations/bristol-rubbish-removal",
      },
      {
        title: "Leeds",
        link: "/locations/leeds-rubbish-removal",
      },
    ],
  },
  {
    heading: "Useful links",
    links: [
      {
        title: "About us",
        link: "/about",
      },
      {
        title: "News",
        link: "/news",
      },
      {
        title: "Reviews",
        link: "/reviews",
      },
      {
        title: "Contact us",
        link: "/contact",
      },
    ],
  },
];
